module.exports = __webpack_public_path__ + "img/dummyLogo.6e5714be.png";